// What takes the text box's place while voice is on: what is happening (Listening,
// Thinking, Speaking), a small microphone meter, and a button to end voice. What is being
// heard right now shows in the conversation, as a listening bubble.

import { useEffect, useRef } from 'react';

import type { Voice } from '../voice/useVoice.js';

const WORDS = {
  starting: 'Starting',
  listening: 'Listening',
  thinking: 'Thinking',
  speaking: 'Speaking',
} as const;

export function VoiceStrip({ voice }: { voice: Voice }): JSX.Element {
  const fill = useRef<HTMLSpanElement>(null);
  const { subscribeLevel } = voice;

  // The meter repaints on its own, straight on the element: the level changes many times a
  // second and the rest of the screen has no reason to render for it.
  useEffect(
    () =>
      subscribeLevel((level) => {
        if (fill.current !== null) {
          fill.current.style.transform = `scaleX(${Math.max(0.04, level)})`;
        }
      }),
    [subscribeLevel],
  );

  return (
    <div className="voiceStrip">
      <div className="voiceStrip__row">
        <span className="voiceStrip__phase" role="status">
          {WORDS[voice.phase]}
        </span>
        <span className="voiceStrip__meter" aria-hidden="true">
          <span className="voiceStrip__fill" ref={fill} />
        </span>
        <button type="button" className="composer__voice" onClick={voice.end}>
          End voice
        </button>
      </div>
    </div>
  );
}
